export default "__VITE_ASSET__D4jZC7bc__"